<template>
    <div id="navigatordevicehealth">
      <NavbarComponent :loadingStatus="loading">Navigator Device Health</NavbarComponent>
      
      <section>
      <div v-if="!loading" class="container is-fluid">
    <p class="text-center"> Last Updated: {{currentTime}} </p>
      <p> Filter Location: <input type="text" id="input" v-model="filterLocation"></p>
      
   
        
             <table class="table">
             <thead>
    <tr>
            <th>Device Login Name</th>
            <th>Activity Count</th>
            <th>Last Login:</th>
            <th>Location</th>
    </tr>
  </thead>
  <tfoot>
  </tfoot>
  
   <tbody>

     <template v-for="device in filteredDevices">
       <template v-if="device.activityCount > 0">
         <tr  bgcolor="#96E9A4">
     <th>{{device.loginName}}</th>
        <td> {{device.activityCount}} </td>
     <td>{{device.lastLogin}}</td>
     <td>{{device.location}}</td>
     </tr>
     </template>
            <template v-else>
         <tr  bgcolor="#FF8B8B">
     <th>{{device.loginName}}</th>
        <td> {{device.activityCount}} </td>
     <td>{{device.lastLogin}}</td>
     <td>{{device.location}}</td>
     </tr>
     </template>
     </template>
    
    
    
    
    </tbody>
    </table>
    
    
   

             <!--
            <div v-for="device in filteredDevices">
                 <b-card v-if="device.activityCount > 0" :title="device.loginName" bg-variant="success">
                     <p class="card-text">Activity Count: {{device.activityCount}} </p>
                      <p class="card-text">Last Login: {{device.lastLogin}} </p>
                      <p class="card-text">Location: {{device.location}} </p>
                 </b-card>

                  <b-card v-else :title="device.loginName" bg-variant="danger">
                    <p class="card-text">Activity Count: {{device.activityCount}}</p>
                           <p class="card-text">Last Login: {{device.lastLogin}} </p>
                            <p class="card-text">Location: {{device.location}} </p>
                  </b-card>
           
            </div>
        </b-card-group>
        
        -->
 <!-- Print the devices data for debugging --> 
<!--<p>{{devices}}</p>-->
        </div>
    </section>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import NavbarComponent from '@/components/NavbarComponent.vue'

export default {
  name: 'NavigatorDeviceHealth',
  props: {
  },
  components: {NavbarComponent},
  data: function() {return  { devices: [],
       
        loading: false,
        currentTime: '',
        filterLocation: '',
        }
        },
        
        
         computed: {
                
                filteredDevices(){
                    return _.orderBy(this.devices.filter(device => device.location.includes(this.filterLocation)),'loginName','asc'); //filter all tasks not completed
                    },
                },
        methods: {
            
        //Updates Current Time Method
        updateCurrentTime() {
        this.currentTime = moment().format('LTS')
        },
        
        async updateDevices() {
            
    this.loading=true;                    
var endTime = new Date().getTime();  //Curent Time in Unix
var startTime = endTime - 2*60*60*1000; //Current Time - 24 hours

//Navigator devices API url
//requires userId, starttime and endtime in unix (with milliseconds)
//using CORS proxy to bypass the No Access-Control-Allow-Origin header in server
//see https://gist.github.com/jesperorb/6ca596217c8dfba237744966c2b5ab1e for more details on how to handle CORs client-side

const url = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release/users/" + this.$store.getters.navigatorUserId.toString() + "/devices?startDate=" + startTime.toString() + "&endDate=" + endTime.toString();

            
            
                  return await this.$axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}})
                  .then(response => {
            
                
            //When receieve response, change lastLogin time from unix to date-time format    
            var step;
            
            //iterate through whole data array
            for (step = 0; step < response.data.length; step++) {
            //use the moment javascript library to change form unix to date time formatting     
            response.data[step].lastLogin = moment.unix(response.data[step].lastLogin/1000).format('LLLLZ');
             }
             
            //set this Vue instance devices data with the formatted reponse data
            this.devices= response.data
            
            //updates current Time
            this.currentTime = moment().format('YYYY-MM-DD HH:mm:ssZ');
            
                this.loading=false;
            
          }).catch((error)=>{
          console.log(error.message);
          this.loading=false;
        })
        }
        
        
        ,
        
        async loginAndUpdateDevices(){
            await this.updateDevices();
        }
        
        },
        
        //Mounted Stage
        mounted() {
            
        //this.$axios http get request with username passwor authentication to Navigator API
        this.updateDevices();
        },
        
          //Created Stage
          created() {
              //this.updateDevices()
  },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table th {
  color: black  ;
}
.table {
  color: black  ;
}
</style>
